// Sigorta tablosunun sütunları; anahtarlar ve sıra eski tabloyla aynı
// (iç içe alanlar "tür.alan" biçiminde). Metinler: insurance.columns.<id>.

export const INSURANCE_COLUMNS = {
  employeeName: { id: 'employeeName', type: 'text', width: 240 },
  hasBES: { id: 'hasBES', type: 'select', width: 150 },
  'accidentInsurance.startDate': { id: 'accidentStart', type: 'date', width: 210 },
  'accidentInsurance.endDate': { id: 'accidentEnd', type: 'date', width: 190 },
  'complementaryHealth.startDate': { id: 'healthStart', type: 'date', width: 260 },
  'complementaryHealth.endDate': { id: 'healthEnd', type: 'date', width: 240 },
  'malpractice.startDate': { id: 'malpracticeStart', type: 'date', width: 220 },
  'malpractice.endDate': { id: 'malpracticeEnd', type: 'date', width: 200 },
  cost: { id: 'cost', type: 'text', width: 150 },
};

export const COLUMN_KEYS = Object.keys(INSURANCE_COLUMNS);
export const DEFAULT_VISIBLE_COLUMNS = Object.fromEntries(COLUMN_KEYS.map((key) => [key, true]));
export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['employeeName'];

// Eski tablodaki gibi her süzgeç seçildiği / yazıldığı anda uygulanır
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
